import { combineReducers } from 'redux'

import { register, login, forgotPassword, userCurrentStorage } from './auth.reducer'
import { profileDeleteSw, profilePasswordChangeSw } from './profile.reducer'

const rootReducer = combineReducers({
  register,
  login,
  forgotPassword,
  userCurrentStorage,
  profileDeleteSw,
  profilePasswordChangeSw
});

export default rootReducer